import { useEffect, useState } from 'react';

import { cn } from '@playbooks/ui/lib/utils';

import type { DocsHeading } from 'types/docs';

const DocsTocSection = ({ headings }: { headings: DocsHeading[] }) => {
	const [activeId, setActiveId] = useState(headings[0]?.id || '');

	useEffect(() => {
		const elements = headings.map(heading => document.getElementById(heading.id)).filter(Boolean) as HTMLElement[];
		if (!elements.length) return;

		const observer = new IntersectionObserver(
			entries => {
				const visible = entries.find(entry => entry.isIntersecting);
				if (visible) setActiveId(visible.target.id);
			},
			{ rootMargin: '-96px 0px -70% 0px', threshold: [0, 1] },
		);
		elements.forEach(element => observer.observe(element));
		return () => observer.disconnect();
	}, [headings]);

	if (!headings.length) return null;

	return (
		<nav aria-label='On this page'>
			<p className='mb-3 text-xs font-medium text-foreground'>On this page</p>
			<ul className='space-y-1'>
				{headings.map(heading => {
					const linkClassName = cn(
						'block border-l py-1 text-xs leading-5 transition-colors',
						heading.depth === 3 ? 'pl-5' : 'pl-3',
						activeId === heading.id
							? 'border-foreground text-foreground'
							: 'border-transparent text-foreground-body hover:text-foreground',
					);
					return (
						<li key={heading.id}>
							<a href={`#${heading.id}`} className={linkClassName}>
								{heading.title}
							</a>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};

export { DocsTocSection };
